const languages = require('./languages');

const findLanguge = language => languages.find(lang => lang.locale === language);

module.exports = findLanguge;
